<div class="justify-center px-[60px] py-[30px] ">
  <h5 class="text-[16px] leading-[26px] font-semibold">Return on Points (ROP)</h5>
  <p class="font-normal text-[12px] leading-[20px] text-[#636363]">
    Return on Points (ROP) measures how many points you earn compared to how many points you spend.
    If you spend 10 points and earn 12 points, your ROP is 20% or (12-10)/10.
    When other Members like your comments or ideas, you earn points.
  </p>
</div>  